import {
  Alert,
  Button,
  ButtonGroup,
  IconButton,
  closeCurrentDialog,
  copyToClipboard,
} from 'platform/components';
import {Box, HStack, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

export interface ServiceAccountKeyResultDialogContentProps extends RequiredTestIdProps {
  keyId: string;
  privateKeyPem: string;
}

export function ServiceAccountKeyResultDialogContent(
  props: ServiceAccountKeyResultDialogContentProps
) {
  const privateKeyLines = props.privateKeyPem.split('\n');

  return (
    <VStack spacing={4}>
      <Alert
        variant="warning"
        title={i18n.t('entity.serviceAccount.labels.privateKeyWarningTitle')}
        message={i18n.t('entity.serviceAccount.labels.privateKeyWarningDescription')}
        data-testid={suffixTestId('warning', props)}
      />

      <VStack spacing={1}>
        <Text size="small" color="tertiary">
          {i18n.t('entity.serviceAccount.labels.keyId')}
        </Text>
        <HStack spacing={2} align="center" justify="space-between">
          <Text size="small" data-testid={suffixTestId('keyId', props)}>
            {props.keyId}
          </Text>
          <IconButton
            icon="content/copy"
            priority="secondary"
            onClick={() => copyToClipboard(props.keyId)}
            aria-label={i18n.t('general.actions.copyToClipboard')}
            data-testid={suffixTestId('copyKeyId', props)}
          />
        </HStack>
      </VStack>

      <VStack spacing={1}>
        <Text size="small" color="tertiary">
          {i18n.t('entity.serviceAccount.labels.privateKey')}
        </Text>
        <Box backgroundColor="palettes.neutral.20.100" borderRadius="small" padding={3}>
          <HStack spacing={2} align="flex-start" justify="space-between">
            <VStack spacing={0}>
              {privateKeyLines.map((line, index) => (
                // eslint-disable-next-line react/no-array-index-key -- Pre-existing violation
                <Text key={`${index}-${line}`} size="small">
                  {line}
                </Text>
              ))}
            </VStack>
            <IconButton
              icon="content/copy"
              priority="secondary"
              onClick={() => copyToClipboard(props.privateKeyPem)}
              aria-label={i18n.t('general.actions.copyToClipboard')}
              data-testid={suffixTestId('copyPrivateKey', props)}
            />
          </HStack>
        </Box>
        <Text size="small" color="tertiary">
          {i18n.t('entity.serviceAccount.labels.publicKeyAvailabilityHint')}
        </Text>
      </VStack>

      <ButtonGroup align="right">
        <Button
          variant="primary"
          onClick={closeCurrentDialog}
          title={i18n.t('entity.serviceAccount.actions.privateKeySaved')}
          data-testid={suffixTestId('confirm', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
